function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import SweetAlert from 'sweetalert-react';
import moment from 'moment';
import AsyncButton from "../../../../components/core/button/AsyncButton";
import ApplicationIntake from "../../../../components/Applications/ApplicationIntake";
import CalendarInput from "../../../../components/CalendarInput";
import { useProgramIntakes } from "../../../../data/programIntakes";
import SidebarRow from "../SidebarRow/SidebarRow";
import { _SidebarDoubleInput, _SidebarDoubleInputWrapper, _SaveButton, _SidebarDatesWrapper, _LabeledSpan } from "../styles";
import { _FadeTransition } from "../../../../components/style";
import { useEventTracker } from '@applyboard/ui-utils';
import { getCurrentStage } from "../../../../util/getCurrentStage";
var CalendarContent = function CalendarContent(value, name, permission, changeHandler, isInternalUserForIntake, label) {
  var labeledSpan = /*#__PURE__*/React.createElement(_LabeledSpan, {
    className: "labeled-span"
  }, /*#__PURE__*/React.createElement("label", null, label), value && value.length ? /*#__PURE__*/React.createElement("span", null, moment(value).format('YYYY-MMM-DD')) : /*#__PURE__*/React.createElement("span", {
    className: "na-span"
  }, "N/A"));
  if (isInternalUserForIntake) {
    return /*#__PURE__*/React.createElement(CalendarInput, {
      value: value || '',
      error: "",
      name: name,
      disabled: permission,
      onChange: changeHandler
    });
  }
  return labeledSpan;
};
var startDateVisible = function startDateVisible(readyForVisa, isInternalUserForIntake, deferralInProgress) {
  return readyForVisa && isInternalUserForIntake || readyForVisa && !isInternalUserForIntake && !deferralInProgress;
};
var alternateStartDateVisible = function alternateStartDateVisible(readyForVisa, isInternalUserForIntake, eslAlternateActualStartDate, programAlternateActualStartDate, deferralInProgress) {
  return readyForVisa && isInternalUserForIntake || readyForVisa && !isInternalUserForIntake && (eslAlternateActualStartDate || programAlternateActualStartDate) && !deferralInProgress;
};
var StartDates = function StartDates(_ref) {
  var _application$program, _application$program_, _application$program_2, _application$program_3, _application$program_4, _application$program_5, _application$program_6;
  var application = _ref.application,
    student = _ref.student,
    hasPermission = _ref.hasPermission,
    onEslDateChange = _ref.onEslDateChange,
    onAcademicDateChange = _ref.onAcademicDateChange,
    dirty = _ref.dirty,
    onSave = _ref.onSave,
    onSaveAlertShow = _ref.onSaveAlertShow,
    confirmonSave = _ref.confirmonSave,
    resetOnSave = _ref.resetOnSave,
    cancelonSave = _ref.cancelonSave,
    shouldShowIntakeStatus = _ref.shouldShowIntakeStatus,
    isInternalUserForIntake = _ref.isInternalUserForIntake,
    eslActualStartDate = _ref.eslActualStartDate,
    programActualStartDate = _ref.programActualStartDate,
    eslAlternateActualStartDate = _ref.eslAlternateActualStartDate,
    programAlternateActualStartDate = _ref.programAlternateActualStartDate,
    onEslActualStartDateChange = _ref.onEslActualStartDateChange,
    onProgramActualStartDateChange = _ref.onProgramActualStartDateChange,
    onEslAlternateActualStartDateChange = _ref.onEslAlternateActualStartDateChange,
    onProgramAlternateActualStartDateChange = _ref.onProgramAlternateActualStartDateChange,
    readyForVisa = _ref.readyForVisa,
    deferralInProgress = _ref.deferralInProgress,
    isInitialActualStartDates = _ref.isInitialActualStartDates,
    NewApplicationIntake = _ref.NewApplicationIntake;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var defaultProgramIntakeQuery = {
    hasVisas: student.has_visas,
    nationality: student.nationality_code,
    ignoreAcceptingApps: application === null || application === void 0 ? void 0 : application.paid
  };
  var _useProgramIntakes = useProgramIntakes(_objectSpread({
      programId: application === null || application === void 0 ? void 0 : (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.id,
      enabled: !!(application !== null && application !== void 0 && application.program)
    }, defaultProgramIntakeQuery)),
    programIntakes = _useProgramIntakes.programIntakes;
  var _useProgramIntakes2 = useProgramIntakes(_objectSpread({
      id: application === null || application === void 0 ? void 0 : (_application$program_ = application.program_esl) === null || _application$program_ === void 0 ? void 0 : _application$program_.id,
      programId: application === null || application === void 0 ? void 0 : (_application$program_2 = application.program_esl) === null || _application$program_2 === void 0 ? void 0 : _application$program_2.id,
      enabled: !!(application !== null && application !== void 0 && application.program_esl)
    }, defaultProgramIntakeQuery)),
    programIntakesESL = _useProgramIntakes2.programIntakes;
  var academicIntakeComponent = NewApplicationIntake ? /*#__PURE__*/React.createElement(NewApplicationIntake, {
    intakes: programIntakes,
    intakesESL: programIntakesESL,
    application: {
      id: application === null || application === void 0 ? void 0 : application.id,
      intake: application === null || application === void 0 ? void 0 : application.intake,
      intakeEsl: application === null || application === void 0 ? void 0 : application.intake_esl,
      admissionType: application === null || application === void 0 ? void 0 : application.admission_type,
      academicSubmissionDeadline: application === null || application === void 0 ? void 0 : application.academic_submission_deadline,
      eslSubmissionDeadline: application === null || application === void 0 ? void 0 : application.esl_submission_deadline,
      paid: application === null || application === void 0 ? void 0 : application.paid,
      intakeId: application === null || application === void 0 ? void 0 : application.intake_id,
      eslIntakeId: application === null || application === void 0 ? void 0 : application.esl_intake_id,
      program: {
        intakes: application === null || application === void 0 ? void 0 : application.program.intakes.map(function (currIntake) {
          return {
            available: currIntake.available,
            deadline: currIntake.deadline,
            startDate: currIntake.start_date
          };
        })
      },
      programEsl: {
        intakes: application === null || application === void 0 ? void 0 : (_application$program_3 = application.program_esl) === null || _application$program_3 === void 0 ? void 0 : _application$program_3.intakes.map(function (currIntake) {
          return {
            available: currIntake.available,
            deadline: currIntake.deadline,
            startDate: currIntake.start_date
          };
        }),
        minLength: application === null || application === void 0 ? void 0 : (_application$program_4 = application.program_esl) === null || _application$program_4 === void 0 ? void 0 : _application$program_4.min_length
      }
    },
    readOnly: !hasPermission('intake_update'),
    esl: false,
    allowEslEdit: hasPermission('intake_update'),
    onChange: onAcademicDateChange,
    shouldShowIntakeStatus: isInternalUserForIntake || shouldShowIntakeStatus
  }) : /*#__PURE__*/React.createElement(ApplicationIntake, {
    intakes: programIntakes,
    intakesESL: programIntakesESL,
    application: application,
    student: student,
    showAvailability: hasPermission('intake_update'),
    readOnly: !hasPermission('intake_update'),
    esl: false,
    onChange: onAcademicDateChange,
    shouldShowIntakeStatus: isInternalUserForIntake || shouldShowIntakeStatus
  });
  var eslIntakeComponent = NewApplicationIntake ? /*#__PURE__*/React.createElement(NewApplicationIntake, {
    intakes: programIntakes,
    intakesESL: programIntakesESL,
    application: {
      id: application === null || application === void 0 ? void 0 : application.id,
      intake: application === null || application === void 0 ? void 0 : application.intake,
      intakeEsl: application === null || application === void 0 ? void 0 : application.intake_esl,
      admissionType: application === null || application === void 0 ? void 0 : application.admission_type,
      academicSubmissionDeadline: application === null || application === void 0 ? void 0 : application.academic_submission_deadline,
      eslSubmissionDeadline: application === null || application === void 0 ? void 0 : application.esl_submission_deadline,
      paid: application === null || application === void 0 ? void 0 : application.paid,
      intakeId: application === null || application === void 0 ? void 0 : application.intake_id,
      eslIntakeId: application === null || application === void 0 ? void 0 : application.esl_intake_id,
      program: {
        intakes: application === null || application === void 0 ? void 0 : application.program.intakes.map(function (currIntake) {
          return {
            available: currIntake.available,
            deadline: currIntake.deadline,
            startDate: currIntake.start_date
          };
        })
      },
      programEsl: {
        intakes: application === null || application === void 0 ? void 0 : (_application$program_5 = application.program_esl) === null || _application$program_5 === void 0 ? void 0 : _application$program_5.intakes.map(function (currIntake) {
          return {
            available: currIntake.available,
            deadline: currIntake.deadline,
            startDate: currIntake.start_date
          };
        }),
        minLength: application === null || application === void 0 ? void 0 : (_application$program_6 = application.program_esl) === null || _application$program_6 === void 0 ? void 0 : _application$program_6.min_length
      }
    },
    readOnly: !hasPermission('intake_update'),
    esl: true,
    allowEslEdit: hasPermission('intake_update'),
    onChange: onEslDateChange,
    shouldShowIntakeStatus: isInternalUserForIntake || shouldShowIntakeStatus
  }) : /*#__PURE__*/React.createElement(ApplicationIntake, {
    intakes: programIntakes,
    intakesESL: programIntakesESL,
    application: application,
    student: student,
    showAvailability: hasPermission('intake_update'),
    readOnly: !hasPermission('intake_update'),
    esl: true,
    allowEslEdit: hasPermission('intake_update'),
    onChange: onEslDateChange,
    shouldShowIntakeStatus: isInternalUserForIntake || shouldShowIntakeStatus
  });
  return /*#__PURE__*/React.createElement("div", null, !readyForVisa || isInternalUserForIntake || deferralInProgress ? /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Intake(s)",
    key: "Intake(s)",
    content: /*#__PURE__*/React.createElement(_SidebarDatesWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInputWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-esl-dropdown"
    }, eslIntakeComponent), /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-academic-dropdown"
    }, academicIntakeComponent)), dirty && !readyForVisa && !isInitialActualStartDates && /*#__PURE__*/React.createElement(_FadeTransition, {
      css: "display: flex; align-items: center;"
    }, /*#__PURE__*/React.createElement(_SaveButton, {
      "data-cy": "sidebar-dates"
    }, /*#__PURE__*/React.createElement(AsyncButton, {
      onClick: onSave
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "check"
    })))))
  }) : null, startDateVisible(readyForVisa, isInternalUserForIntake, deferralInProgress) ? /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Start Date(s)",
    key: "Start Date(s)",
    content: /*#__PURE__*/React.createElement(_SidebarDatesWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInputWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-esl-dropdown"
    }, CalendarContent(eslActualStartDate, 'eslActualStartDate', !hasPermission('intake_update'), onEslActualStartDateChange, isInternalUserForIntake, 'ESL')), /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-academic-dropdown"
    }, CalendarContent(programActualStartDate, 'programActualStartDate', !hasPermission('intake_update'), onProgramActualStartDateChange, isInternalUserForIntake, 'Academic'))))
  }) : null, alternateStartDateVisible(readyForVisa, isInternalUserForIntake, eslAlternateActualStartDate, programAlternateActualStartDate, deferralInProgress) ? /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Alt. Start Date(s)",
    key: "Alt. Start Date(s)",
    content: /*#__PURE__*/React.createElement(_SidebarDatesWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInputWrapper, null, /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-esl-dropdown",
      className: "alt-dates"
    }, CalendarContent(eslAlternateActualStartDate, 'eslAlternateActualStartDate', !hasPermission('intake_update'), onEslAlternateActualStartDateChange, isInternalUserForIntake)), /*#__PURE__*/React.createElement(_SidebarDoubleInput, {
      "data-cy": "start-dates-academic-dropdown",
      className: "alt-dates"
    }, CalendarContent(programAlternateActualStartDate, 'programAlternateActualStartDate', !hasPermission('intake_update'), onProgramAlternateActualStartDateChange, isInternalUserForIntake))), dirty && hasPermission('intake_update') && alternateStartDateVisible && !isInitialActualStartDates && /*#__PURE__*/React.createElement(_FadeTransition, {
      css: "display: flex; align-items: center;"
    }, /*#__PURE__*/React.createElement(_SaveButton, {
      "data-cy": "sidebar-dates"
    }, /*#__PURE__*/React.createElement(AsyncButton, {
      onClick: onSave
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "check"
    })))))
  }) : null, /*#__PURE__*/React.createElement(SweetAlert, {
    show: onSaveAlertShow,
    title: "",
    text: "Are you sure you want to update the start date(s)?",
    type: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    onConfirm: function onConfirm() {
      trackEvent({
        event: 'Single Application - Application Sidebar - Clicked confirm on Intake dropdown',
        data: {
          currentStage: getCurrentStage(application)
        }
      });
      confirmonSave();
    },
    onCancel: resetOnSave,
    onClose: cancelonSave,
    onEscapeKey: cancelonSave
  }));
};
export default StartDates;